var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_cof.js
// module id = 343
// module chunks = 0